import Contract from "slotworks/utils/contract";
import RevolverWinTransitions from "./revolver-win-transitions";
import Layers from "slotworks/graphics/layers/layers";
import * as TweenJS from "slotworks/utils/tween";
import { sequence } from "slotworks/utils/race-utils";
import { ZoomOut, ZoomIn } from "slotworks/graphics/animation/base-animations";
import soundManager from "slotworks/sound/sound-manager";
import Logger = require("js-logger");

export default class BonusWinTransitions extends RevolverWinTransitions {
    
    private value: PIXI.extras.BitmapText;
    public in(): Contract<void> {
        return new Contract((resolve) => {   
            RevolverWinTransitions.setOrientationChange();
            this.value = Layers.CelebrationContent.getBitmapText("value");
            ZoomIn(this.value, 200).then(()=>resolve(null));
        });
    }

    public out(): Contract<void> {                  
        TweenJS.removeAll(this.value.scale);
        return sequence([
            () => Contract.wrap(() => { soundManager.customEvent("plaque_transition") }),
            () => ZoomOut(this.value, 150),  
            () => Contract.wrap(() =>  RevolverWinTransitions.removeOrientationChange()),
            () => this.zoomOutStacks()
        ]);        
    }

}